"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
//Primary
var claytonBlue = {
  standard: "#0075c9",
  hover: "#179eff",
  tint: "#e5f5ff",
  light: "#e2f7ff",
  className: "clayton-blue"
};
var black = {
  standard: "#25292d",
  hover: "#4C4D50",
  tint: "#e4e5e7",
  className: "standard-black"
};
var white = {
  standard: "#ffffff",
  hover: "#e4e5e7",
  tint: "#4e5255",
  className: "standard-white"
};

//Secondary
var kiddiePool = {
  standard: "#00b0ac",
  hover: "#1edad5",
  tint: "#e5f7f7",
  light: "#dafefd",
  className: "kiddie-pool"
};
var navy1 = {
  standard: "#0c1e34",
  className: "navy-1"
};
var grey6 = {
  standard: "#f3f5f7",
  className: "grey-6"
};
var rubberDucky = {
  standard: "#ffc50a",
  hover: "#ffdc6a",
  tint: "#fff9e6",
  textColor: "#000000",
  light: "#fff6db",
  className: "rubber-ducky"
};
var summerNight = {
  standard: "#352269",
  hover: "#6443be",
  tint: "#eae8f0",
  className: "summer-night"
};
var transparent = {
  standard: "#00000000",
  hover: "#00000000",
  tint: "#00000000",
  borderColor: "#FFFFFF",
  textColor: "#FFFFFF",
  className: "transparent"
};

//Others
var grey1 = {
  standard: "#4e5255",
  className: "grey-1"
};
var grey2 = {
  standard: "#777b7e",
  className: "grey-2"
};
var grey3 = {
  standard: "#a1a3a6",
  className: "grey-3"
};
var grey4 = {
  standard: "#cacccf",
  className: "grey-4"
};
var grey5 = {
  standard: "#e4e5e7",
  className: "grey-5"
};
var grey7 = {
  standard: "#f7f9fb",
  className: "grey-7"
};
var navy2 = {
  standard: "#1b3453",
  className: "navy-2"
};
var navy3 = {
  standard: "#29476c",
  className: "navy-3"
};
var navy4 = {
  standard: "#4c75a7",
  className: "navy-4"
};
var claytonBlue2 = {
  standard: "#003f8c",
  className: "clayton-blue-2"
};
var claytonGreen = {
  standard: "#97d700",
  hover: "#c1e766",
  light: "#e2ffc6",
  tint: "#f2fae0",
  className: "clayton-green"
};
var kiddiePool2 = {
  standard: "#017f93",
  className: "kiddie-pool-2"
};
var barnDoor = {
  standard: "#b21f28",
  className: "barn-door"
};
var cheesePuff = {
  standard: "#f68c2c",
  hover: "#ffb068",
  tint: "#fef3e9",
  className: "cheese-puff"
};
var ladyBug = {
  standard: "#ef4b5d",
  hover: "#ff7f8d",
  tint: "#fdedee",
  light: "#ffe5e6",
  highContrast: "#bc2636",
  className: "lady-bug"
};
var dusk = {
  standard: "#8d83be",
  light: "#e8e4fc",
  className: "dusk"
};
var hoseWater = {
  standard: "#97d4ca",
  className: "hose-water"
};
var freshGrass = {
  standard: "#4f9e44",
  className: "fresh-grass"
};
var darkFreshGrass = {
  standard: "#37862c",
  className: "dark-fresh-grass"
};
var bigSky = {
  standard: "#00a0dd",
  className: "big-sky"
};
var wetCement = {
  standard: "#51748b",
  className: "wet-cement"
};
var bedtime = {
  standard: "#06292f",
  className: "bed-time"
};
var veryLightBlue = {
  standard: "#f1faff",
  className: "very-light-blue"
};
var darkBlue = {
  standard: "#004b8d",
  hover: "#026ecd",
  tint: "#ccdbe8",
  light: "#b2c9dd",
  className: "dark-blue"
};
var Colors = {
  primary: {
    claytonBlue: claytonBlue,
    black: black,
    white: white
  },
  secondary: {
    kiddiePool: kiddiePool,
    navy1: navy1,
    grey6: grey6,
    rubberDucky: rubberDucky,
    summerNight: summerNight,
    transparent: transparent
  },
  accent: {
    grey1: grey1,
    grey2: grey2,
    grey3: grey3,
    grey4: grey4,
    grey5: grey5,
    grey7: grey7,
    navy2: navy2,
    navy3: navy3,
    navy4: navy4,
    claytonBlue2: claytonBlue2,
    claytonGreen: claytonGreen,
    kiddiePool2: kiddiePool2,
    barnDoor: barnDoor,
    cheesePuff: cheesePuff,
    ladyBug: ladyBug,
    dusk: dusk,
    hoseWater: hoseWater,
    freshGrass: freshGrass,
    darkFreshGrass: darkFreshGrass,
    bigSky: bigSky,
    wetCement: wetCement,
    bedtime: bedtime,
    veryLightBlue: veryLightBlue,
    darkBlue: darkBlue
  }
};
var _default = exports["default"] = Colors;